import { getSVG } from './components/icons-loader.js';
import { slickSliderGenerator, displayBrandSliderOnLoad} from './components/sliders.js';
import { showMoreFaqs, accordion } from './components/accordion.js';
import { videoLazyLoading } from './components/video.js'
import { handleDemoFormOrBot, toggleBotAndResetScrollBottomPageClass } from './components/get-a-demo.js';

document.addEventListener("DOMContentLoaded", async function () {
  await slickSliderGenerator('brand', '.logos-container');
  displayBrandSliderOnLoad();
  slickSliderGenerator('workflow_4_steps_big', '.workflow-big-container');
  accordion('.faqs-cards');
  showMoreFaqs();
  getSVG();
  videoLazyLoading();
  handleDemoFormOrBot();

  const mutationObserver = new MutationObserver(() => {
    console.log('bot iframe added');
    toggleBotAndResetScrollBottomPageClass();
  });
  const observerTarget = document.querySelector('body');
  mutationObserver.observe(observerTarget, { childList: true })
});
